import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import actions from 'redux/actions'
import { useConnect } from 'sb-redux-hook'
import { useState, useCallback } from 'sb-hooks'
import { constants } from 'common/helpers'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import Icon from 'components/_new/ui/Icon/Icon'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import ButtonWithIcons from 'components/_new/Button/ButtonWithIcons/ButtonWithIcons'

import messages from './messages'
import s from './CopyButton.scss'


const CopyButton = ({ className, rounded, onClick }) => {
  const [ isCopied, setCopied ] = useState(false)

  const { directReferralCode } = useConnect({
    directReferralCode: (state) => state.models.me.referralCodes ? state.models.me.referralCodes.direct : null,
  })

  const handleCopy = useCallback(() => {
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)

    actions.models.me.stopInviteTracking()

    if (typeof onClick === 'function') {
      onClick()
    }
  }, [ onClick ])

  const buttonTitle = isCopied
    ? messages.copied
    : rounded ? messages.buttonTitleShort : messages.buttonTitle

  return (
    <CopyToClipboard text={directReferralCode} onCopy={handleCopy}>
      {
        rounded ? (
          <Button
            className={cx(s.roundButton, className)}
            size="xs"
            color={null}
            loading={Boolean(!directReferralCode)}
            dataTestId={constants.testIds.invite.linkButton}
          >
            <Icon
              className={s.icon}
              name="link"
              color="black"
            />
            <Text
              message={buttonTitle}
              size="14-24"
              color="black"
              semibold
            />
          </Button>
        ) : (
          <ButtonWithIcons
            className={s.button}
            title={buttonTitle}
            size="md"
            color={null}
            weight="medium"
            leftIcon="link"
            loading={Boolean(!directReferralCode)}
            dataTestId={constants.testIds.invite.linkButton}
            fullWidthOnMobile
          />
        )
      }
    </CopyToClipboard>
  )
}


CopyButton.propTypes = {
  onClick: PropTypes.func,
}

export default CopyButton
